"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var activityListApi = _interopRequireWildcard(require("@/api/activityListApi"));
var _systemSetting = require("@/api/systemSetting.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {},
  data: function data() {
    return {
      itemInfo: {},
      activeSetting: 1,
      userType: null,
      // 用户类型
      textList: [{
        label: '文字公告',
        key: 1
      }, {
        label: '文章新闻',
        key: 2
      }],
      text: [{
        key: 1,
        name: '居左'
      }, {
        key: 2,
        name: '居中'
      }, {
        key: 3,
        name: '居右'
      }],
      textSelsected: [],
      textSelsectedUrl: []
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // 确保所有必需的嵌套对象都存在
        var defaultData = {
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 0,
            mr: 0
          }
        };
        // 合并传入的数据和默认数据
        this.itemInfo = _objectSpread(_objectSpread(_objectSpread({}, defaultData), val), {}, {
          formMargin: _objectSpread(_objectSpread({}, defaultData.formMargin), val.formMargin || {})
        });
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    // 获取用户类型
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    handleList: function () {
      var _handleList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return activityListApi.getPidList();
            case 1:
              res = _context.v;
              this.textSelsected = res.list;
              console.log(this.textSelsected, 'this.textSelsected');
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleList() {
        return _handleList.apply(this, arguments);
      }
      return handleList;
    }(),
    handleChange: function () {
      var _handleChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(cid) {
        var _this$textSelsected$f;
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return activityListApi.getPidListPages(cid);
            case 1:
              data = _context2.v;
              this.textSelsectedUrl = data.list;
              cid = cid ? cid : this.itemInfo.textType;
              this.itemInfo.typeName = (_this$textSelsected$f = this.textSelsected.find(function (_ref) {
                var id = _ref.id;
                return id === cid;
              })) === null || _this$textSelsected$f === void 0 ? void 0 : _this$textSelsected$f.name;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleChange(_x) {
        return _handleChange.apply(this, arguments);
      }
      return handleChange;
    }(),
    updateItem: function updateItem() {
      this.$emit("input", this.itemInfo);
    },
    modalPicTap: function modalPicTap(tit, type) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (type == 'logoUrl') {
          _this.$set(_this.itemInfo, 'logoUrl', img[0].sattDir);
        } else if (type == 'bgImg') {
          _this.$set(_this.itemInfo, 'bgImg', img[0].sattDir);
        }
        ;
        _this.updateItem();
      }, tit, 'system');
    },
    removeImg: function removeImg(type) {
      if (type == 'logoUrl') {
        this.$set(this.itemInfo, 'logoUrl', '');
      } else if (type == 'bgImg') {
        this.$set(this.itemInfo, 'bgImg', '');
      }
      ;
      this.updateItem();
    },
    // 本地上传前的校验
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    // 处理本地上传
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options, fieldName) {
        var file, formData, params, loading, res, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: 1
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context3.p = 1;
              _context3.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context3.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.itemInfo, fieldName, res.url);
                this.updateItem();
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              loading.close();
              this.$message.error('上传失败：' + (_t.message || '请重试'));
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleLocalUpload(_x2, _x3) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }()
  }
};